import { useMemo } from 'react';
import { mapValues } from 'lodash';
import { getIntlMessages } from '../utils';
export default function useIntlMessages(locale, themeKey) {
  var messages = useMemo(function () {
    return mapValues(getIntlMessages(locale, themeKey), 'message');
  }, [locale, themeKey]);
  return messages;
}